import TextMeTheAppForm from './TextMeTheAppForm';
import { connect } from 'react-redux';
import { textAppLink, onChangePhoneNumber } from './actions';
import { TEXT_ME_THE_APP_KEY } from './constants';

export const mapStateToProps = state => {
    return {
        textSent: state[TEXT_ME_THE_APP_KEY].textSent,
        phoneNumberFormatted: state[TEXT_ME_THE_APP_KEY].phoneNumberFormatted,
        textSendError: state[TEXT_ME_THE_APP_KEY].textSendError,
    };
};

export const mapDispatchToProps = {
    textAppLink,
    onChangePhoneNumber,
};

export default connect(mapStateToProps, mapDispatchToProps)(TextMeTheAppForm);
